<template>
  <div class="kds-board-wrap" :style="{ zoom: fontScale }">
    <div v-if="statusView === 'all'" class="kds-columns">
      <kds-column
        v-for="group in visibleGroupDefs"
        :key="group.key"
        :title="$t(group.labelKey)"
        :icon="group.icon"
        :accent-color="group.accent"
        :tickets="groupedTickets[group.key]"
        :density="densitySettings[group.key]"
        :changing-id="changingId"
        @advance="(ticket) => $emit('advance', ticket)"
        @change-status="(ticket, status) => $emit('change-status', ticket, status)"
        @open-details="(ticket) => $emit('open-details', ticket)"
      />
    </div>

    <div v-else class="kds-columns kds-columns--single">
      <kds-column
        :title="$t(activeGroupDef.labelKey)"
        :icon="activeGroupDef.icon"
        :accent-color="activeGroupDef.accent"
        :tickets="groupedTickets[statusView]"
        :density="densitySettings[statusView]"
        :changing-id="changingId"
        @advance="(ticket) => $emit('advance', ticket)"
        @change-status="(ticket, status) => $emit('change-status', ticket, status)"
        @open-details="(ticket) => $emit('open-details', ticket)"
      />
    </div>
  </div>
</template>

<script>
import KdsColumn from "./KdsColumn.vue";
import { KDS_GROUPS } from "./kdsConstants";

export default {
  name: "KdsBoard",
  components: { KdsColumn },
  props: {
    statusView: { type: String, default: "all" },
    groupedTickets: { type: Object, required: true },
    densitySettings: { type: Object, required: true },
    visibleGroups: { type: Array, default: () => [] },
    changingId: { type: [String, Number], default: null },
    fontScale: { type: Number, default: 1 },
  },
  computed: {
    visibleGroupDefs() {
      return KDS_GROUPS.filter((group) => this.visibleGroups.includes(group.key));
    },
    activeGroupDef() {
      return KDS_GROUPS.find((g) => g.key === this.statusView) || KDS_GROUPS[0];
    },
  },
};
</script>

<style scoped>
.kds-board-wrap {
  flex: 1;
  padding: 16px;
  overflow: hidden;
  min-height: 0;
}

.kds-columns {
  display: flex;
  gap: 16px;
  height: 100%;
}

.kds-columns > * {
  flex: 1;
  min-width: 0;
}

.kds-columns--single {
  display: block;
  height: 100%;
}
</style>
